import createIcon from '../../createIcon';

/**
 * @component @name Looks5
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xNSA5SDExVjExSDEzQzE0LjEgMTEgMTUgMTEuODkgMTUgMTNWMTVDMTUgMTYuMTEgMTQuMSAxNyAxMyAxN0g5VjE1SDEzVjEzSDlWN0gxNVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Looks5 = createIcon('Looks5', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM15 9H11V11H13C14.1 11 15 11.89 15 13V15C15 16.11 14.1 17 13 17H9V15H13V13H9V7H15V9Z',
      key: 'vccop4',
    },
  ],
]);

export default Looks5;
